import {getRandomNumber} from "../../util/utils";

export interface IHowItWorksState {
    content: IHowItWorksContent
    loading: boolean
}

export interface IStep {
    title_en: string
    title_mk: string
    title_al: string
    subtitle_en: string
    subtitle_mk: string
    subtitle_al: string
    gif_en: string
    gif_mobile_en: string
    gif_mk: string
    gif_mobile_mk: string
    gif_al: string
    gif_mobile_al: string

    alternative_title_en: string
    alternative_title_mk: string
    alternative_title_al: string
    alternative_subtitle_en: string
    alternative_subtitle_mk: string
    alternative_subtitle_al: string
    alternative_gif_en: string
    alternative_gif_mobile_en: string
    alternative_gif_mk: string
    alternative_gif_mobile_mk: string
    alternative_gif_al: string
    alternative_gif_mobile_al: string

    [key: string]: any
}

export interface IHowItWorksContent {
    videoUrl: string
    videoThumbnail: string
    steps: IStep[]
}

export const initialSteps = {
    title_en: '',
    title_mk: '',
    title_al: '',
    subtitle_mk: '',
    subtitle_en: '',
    subtitle_al: '',
    gif_en: '',
    gif_mobile_en: '',
    gif_mk: '',
    gif_mobile_mk: '',
    gif_al: '',
    gif_mobile_al: '',
    alternative_title_en: '',
    alternative_title_mk: '',
    alternative_title_al: '',
    alternative_subtitle_mk: '',
    alternative_subtitle_en: '',
    alternative_subtitle_al: '',
    alternative_gif_en: '',
    alternative_gif_mobile_en: '',
    alternative_gif_mk: '',
    alternative_gif_mobile_mk: '',
    alternative_gif_al: '',
    alternative_gif_mobile_al: ''
}

export interface IStepNormalized {
    title: string
    subtitle: string
    gif: string
}

export const getRandomStepsArray = (): IStepNormalized[] => {
    const arr: IStepNormalized[] = []
    const numElements = getRandomNumber(5, 7)
    for (let i = 0; i < numElements; i++) {
        arr.push(
            {
                title: i.toString(),
                subtitle: '',
                gif: ''
            }
        )
    }

    return arr
}
